import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import './organization-add-child';

class OrganizationAddChildModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'organization-add-child-modal';
    this.preserve = true;
  }

  renderContents() {
    return html`
      <style>
        bn-modal#organization-add-child-modal {
          --modal-min-width: 55%;
          --modal-min-height: 410px;
        }
      </style>
      <h3 slot="title">Add Organization</h3>
      <organization-add-child
        .href="${this.href}"
        successtext="Organization has been added. Redirecting."
        @organization-added="${this._onResponse}"
      ></organization-add-child>
    `;
  }

  _onResponse(e) {
    const { response } = e.detail;
    if (!response || !response.headers) {
      return;
    }

    const orgId = response.headers.get('Location');
    if (!orgId) {
      return;
    }

    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));

    setTimeout(() => {
      this.close();
      store.dispatch(storeActions.navigate('/organizations/list', { orgId }));
    }, 1000);
  }
}

window.customElements.define('organization-add-child-modal', OrganizationAddChildModal);
